var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import { StyledLabel } from './RadioContainer.style';
import { colorPalette } from '../../colorPalette';
import { useRadioGroup } from '@mui/material/RadioGroup';
export const RadioContainer = (_a) => {
    var { heading, description, margins, noCheckedStyle, dataQa, children } = _a, rest = __rest(_a, ["heading", "description", "margins", "noCheckedStyle", "dataQa", "children"]);
    const radioGroup = useRadioGroup();
    let checked = false;
    if (radioGroup && !noCheckedStyle) {
        checked = radioGroup.value === rest.value;
    }
    return (React.createElement(StyledLabel, { component: "label", margins: margins, checked: checked, "data-qa": dataQa ? dataQa : 'radio-container' },
        React.createElement(Radio, Object.assign({}, rest, { "data-qa": dataQa ? `${dataQa}-radio-button` : 'radio-button' })),
        children ? (children) : (React.createElement(Box, null,
            heading && (React.createElement(Typography, { color: colorPalette.gray900, fontWeight: 600, lineHeight: "18px" }, heading)),
            React.createElement(Typography, { color: colorPalette.gray800, sx: { mt: !heading ? 0 : '3px' }, lineHeight: "18px", marginTop: "4px" }, description)))));
};
